import React, { useEffect, useState } from "react";
import axiosInstance from "../../request";
import { URL } from "../../api";


import {
  Card,
  CardBody,
  CardTitle,
  ListGroup,
  CardSubtitle,
  ListGroupItem,
} from "reactstrap";

const Feeds = () => {
  const [feedData, setFeedData] = useState([]);

  const companyCode = localStorage.getItem("companyCode");
  const branchCode = localStorage.getItem("branch_code");

 useEffect(() => {

    const fetchOverdueData = async () => {

      try {

        const res = await axiosInstance.get(URL.OVERDUE_LIST, {
          params: {
            companyCode,
            branchCode
          }
        });

        let data = res.data || [];

        // Sort by create_date DESC, then id DESC
        data.sort((a, b) => {
          const dateA = new Date(a.create_date);
          const dateB = new Date(b.create_date);

          if (dateA.getTime() === dateB.getTime()) {
            return b.id - a.id;
          }

          return dateB - dateA;
        });

        // Keep only latest 5
        setFeedData(data.slice(0, 5));

      } catch (error) {

        console.error("Error fetching overdue list", error);

      }

    };

    fetchOverdueData();

  }, []);

  return (
    <Card>
      <CardBody>
        <CardTitle tag="h5">Overdue</CardTitle>
        <CardSubtitle className="mb-1 text-muted" tag="h6">
          Overdue Customers
        </CardSubtitle>
        <ListGroup flush className="mt-1">
          {feedData.length > 0 ? (
            feedData.map((feed, index) => (
              <ListGroupItem
                key={index}
                className="border-0 d-flex flex-column"
              >
                <div className="fw-bold mb-1">{feed.customer_name || "-"}</div>
                <div className="text-muted small">
                  Amt: ₹{feed.outstanding_amount?.toLocaleString() || "0"}{" "}
                  &nbsp;|&nbsp; Due: {feed.emi_date || "-"} &nbsp;|&nbsp; DPD:{" "}
                  {feed.dpd || 0} days
                </div>
              </ListGroupItem>
            ))
          ) : (
            <ListGroupItem className="border-0 text-muted">
              No overdue data available
            </ListGroupItem>
          )}
        </ListGroup>
      </CardBody>
    </Card>
  );
};

export default Feeds;
